module.exports = __webpack_public_path__ + "static/media/7.479833f1.jpg";